export default __webpack_public_path__ + "static/portfolio-cover-4-67ee5864caec102d3ccfa650130745a5.jpg";